// Registry barang Mall di klien: meta + kode pelukis (paintCode) yang sudah dikompilasi, diambil malas lewat /api/mall/kode.
// Dipakai avatarDraw (aksesoris yang dipakai warga) dan interiorRender (perabot Mall di ruang dalam).
import { api } from "./api";

const REG = new Map();          // id → { id, jenis, kategori, nama, w, d, injak, harga, paintCode, fn }
const KOMPILASI = new Map();    // paintCode → fungsi (kode draf/pratinjau Studio ikut di-cache di sini)
const antre = new Set();
let timer = null;

const toArr = c => (Array.isArray(c) ? c : typeof c === "string" && c[0] === "#" ? [parseInt(c.slice(1, 3), 16), parseInt(c.slice(3, 5), 16), parseInt(c.slice(5, 7), 16)] : [200, 200, 200]);
export const cssCol = (c, a) => { const v = toArr(c); return `rgba(${v[0] | 0},${v[1] | 0},${v[2] | 0},${a == null ? 1 : a})`; };
export const shadeMall = (c, f) => { const v = toArr(c); return cssCol([Math.min(255, v[0] * f), Math.min(255, v[1] * f), Math.min(255, v[2] * f)]); };
export const uMall = (extra = {}) => ({ cssCol, shade: shadeMall, night: 0, time: 0, zoom: 1, ...extra });

// Kompilasi body kode pelukis: perabot (ctx,P,U) · aksesoris (ctx,A,U). Gagal parse → null (barang tampil sebagai kotak abu).
export function compileMall(code, jenis) {
  if (!code) return null;
  const k = jenis + "\n" + code;
  if (KOMPILASI.has(k)) return KOMPILASI.get(k);
  let fn = null;
  try {
    const body = /function\s+(\w+)\s*\(\s*ctx/.test(code) ? code + `\n${code.match(/function\s+(\w+)\s*\(\s*ctx/)[1]}(ctx, ${jenis === "aksesoris" ? "A" : "P"}, U);` : code;
    const raw = new Function("ctx", jenis === "aksesoris" ? "A" : "P", "U", `"use strict";${body}`);
    fn = (ctx, X, U) => { ctx.save(); try { raw(ctx, X, U); } catch { /* kode barang bermasalah — abaikan frame ini */ } ctx.restore(); };
  } catch { fn = null; }
  KOMPILASI.set(k, fn);
  return fn;
}

export function daftarkanMall(items) {
  for (const it of items || []) REG.set(it.id, { ...it, fn: compileMall(it.paintCode, it.jenis) });
}

// Ambil barang dari registry; bila belum ada, minta ke server (digabung per 30 ms) dan kembalikan null dulu.
export function mallItem(id) {
  const r = REG.get(id);
  if (r) return r.hilang ? null : r;
  if (!antre.has(id)) { antre.add(id); clearTimeout(timer); timer = setTimeout(muatAntre, 30); }
  return null;
}

async function muatAntre() {
  const ids = [...antre]; antre.clear();
  try {
    const d = await api.mallKode(ids.join(","));
    daftarkanMall(d.items);
    for (const id of ids) if (!REG.has(id)) REG.set(id, { id, hilang: true, fn: null });
  } catch { /* coba lagi pada permintaan berikutnya */ }
}

// Pastikan daftar id tersedia (await) → daftar barang yang ditemukan
export async function pastikanMall(ids) {
  const butuh = [...new Set(ids)].filter(i => i && !REG.has(i));
  if (butuh.length) { const d = await api.mallKode(butuh.join(",")); daftarkanMall(d.items); }
  return [...new Set(ids)].map(i => REG.get(i)).filter(r => r && !r.hilang);
}

// Definisi perabot interior dari barang Mall (bentuk sama dengan kat.perabot bawaan + paintCode)
export const defPerabotMall = it => ({ key: `m_${it.id}`, nama: it.nama, kat: "mall", w: it.w || 1, d: it.d || 1, harga: it.harga, injak: !!it.injak, hewan: !!it.hewan, skala: it.skala || 1, paintCode: it.paintCode, mallId: it.id, kategori: it.kategori });
